export default __webpack_public_path__ + "static/media/image 273.bf2943cc.png";